module.exports = {
  NODE_ENV: '"aztest"',
  DS_URL: '"envirodataplayground.canadacentral.cloudapp.azure.com:6020"',
  // Staging (AKS) - Microsoft Auth
  VUE_APP_SIGNALR_HUB_URL: '"https://www.dev.envirodata.io/signalr"',
  VUE_APP_MS_CLIENT_ID: '"28133886-023e-4503-87ea-817f7e396e52"',
  VUE_APP_MS_REDIRECT_URI: '"https://www.dev.envirodata.io/Office365AuthResponse/"',
  VUE_APP_MS_AUTHORITY: '"https://login.microsoftonline.com/e0b2a496-c186-4e92-b4b0-7d466b05d8d9"',
}
